import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarsStaggered,
  faXmark,
  faMagnifyingGlass,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const toggleMobileMenu = () => setShowMobileMenu(!showMobileMenu);
  const closeMobileMenu = () => setShowMobileMenu(false);

  const toggleProductDropdown = () =>
    setIsProductDropdownOpen(!isProductDropdownOpen);
  const toggleServicesDropdown = () =>
    setIsServicesDropdownOpen(!isServicesDropdownOpen);

  useEffect(() => {
    fetch("/data/services.json")
      .then((response) => response.json())
      .then((data) => setSearchResults(data.services.map((item) => item.name)))
      .catch((error) => console.error("Error fetching services:", error));
  }, [query]);

  const handlesearch = (e) => {
    const data = e.target.value;

    setQuery(data);
    console.log("search clicked");
  };

  console.log("query", query);
  console.log(
    "searchResults",
    searchResults.map((item) => item.toLowerCase().includes(query))
  );

  return (
    <>
      <header className="h-auto shadow-md bg-yellow-300 w-full flex flex-wrap lg:flex-nowrap justify-between items-center p-4 lg:px-5 lg:py-4">
        
        <div className="flex items-center justify-between w-full lg:w-auto">
          <a href="#" className="flex items-center">
            <img
              src="/assets/Images/logo.png"
              alt="Logo"
              className="h-8 lg:h-10"
            />
            <p className="text-lg lg:text-2xl font-bold text-indigo-950 ml-2">
              Aditya And Associates
            </p>
          </a>
          <button
            className="block lg:hidden text-gray-900"
            onClick={toggleMobileMenu}
          >
            <FontAwesomeIcon icon={faBarsStaggered} className="h-6 w-6" />
          </button>
        </div>

        <nav className="hidden lg:flex items-center space-x-5">
          <ul className="flex space-x-5">
            <li className="text-gray-800 text-lg hover:underline cursor-pointer">
              <a href="/">Home</a>
            </li>
            <li
              className="text-gray-800 text-lg cursor-pointer relative hover:underline"
              onMouseEnter={() => setIsProductDropdownOpen(true)}
              onMouseLeave={() => setIsProductDropdownOpen(false)}
            >
              <a href="/product">Product</a>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-1 transition-transform duration-300 ${
                  isProductDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isProductDropdownOpen && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-md z-40 w-56">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">Sand</li>
                    <li className="px-4 py-2 hover:bg-gray-100">Cement</li>
                    <li className="px-4 py-2 hover:bg-gray-100">Bricks</li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      Water Proofing Material
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">Marbles</li>
                    <li className="px-4 py-2 hover:bg-gray-100">Granites</li>
                  </ul>
                </div>
              )}
            </li>
            <li
              className="text-gray-800 text-lg cursor-pointer relative hover:underline"
              onMouseEnter={() => setIsServicesDropdownOpen(true)}
              onMouseLeave={() => setIsServicesDropdownOpen(false)}
            >
              <a href="services" rel="noopener noreferrer">
                Services
              </a>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-1 transition-transform duration-300 ${
                  isServicesDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isServicesDropdownOpen && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-md z-40 w-48">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      Water Proofing
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      Interior Work
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      Exterior Work
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      Vastu Suggestions
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">Renovation</li>
                  </ul>
                </div>
              )}
            </li>
            <a href="#aboutUs">
              <li className="text-gray-800 text-lg hover:underline cursor-pointer">
                About Us
              </li>
            </a>
            <a href="#contactUs">
              <li className="text-gray-800 text-lg hover:underline cursor-pointer">
                Contact
              </li>
            </a>
          </ul>
        </nav>


        <div className="w-full lg:w-80 mt-3 lg:mt-0">
          <form className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="text-gray-500 h-4 w-4"
              />
            </div>
            <input
              type="search"
              placeholder="Search here..."
              onChange={handlesearch}
              className="w-full p-2 pl-10 rounded-md border border-gray-300 focus:ring-amber-400 focus:border-amber-400"
            />
            <button
              type="submit"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-amber-500 hover:bg-amber-600 text-white px-3 py-1 rounded-md"
            >
              Search
            </button>
          </form>
        </div>


        <div className="hidden lg:flex space-x-4">
          <a href="tel:+919987858709">
            <img
              src="./svgIcons/phone-call-24.svg"
              alt="Phone"
              className="h-6"
            />
          </a>
          <a href="https://wa.me/+919987858709">
            <img
              src="./svgIcons/whatsapp-128.svg"
              alt="WhatsApp"
              className="h-[21px]"
            />
          </a>
          <a href="mailto:adityassociates0510@gmail.com">
            <img src="./svgIcons/mail-pencil.svg" alt="Email" className="h-6" />
          </a>
        </div>


        <div
          className={`fixed top-0 right-0 h-full w-64 bg-white z-30 transition-transform duration-300 ease-in-out ${
            showMobileMenu ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center p-4">
            <p className="text-xl font-bold">Menu</p>
            <button onClick={closeMobileMenu}>
              <FontAwesomeIcon
                icon={faXmark}
                className="h-6 w-6 text-gray-900"
              />
            </button>
          </div>
          <ul className="space-y-4 px-4">
            <li className="text-gray-800 text-lg hover:underline">Home</li>
            <li
              className="text-gray-800 text-lg hover:underline"
              onClick={toggleProductDropdown}
            >
              Product
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-1 transition-transform duration-300 ${
                  isProductDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isProductDropdownOpen && (
                <ul className="pl-4 mt-2 z-40">
                  <li className="py-1">Sand</li>
                  <li className="py-1">Cement</li>
                  <li className="py-1">Bricks</li>
                  <li className="py-1">Water Proofing Material</li>
                  <li className="py-1">Marbles</li>
                  <li className="py-1">Granites</li>
                </ul>
              )}
            </li>
            <li
              className="text-gray-800 text-lg hover:underline"
              onClick={toggleServicesDropdown}
            >
              <a href="services" rel="noopener noreferrer">
                Services
              </a>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-1 transition-transform duration-300 ${
                  isServicesDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isServicesDropdownOpen && (
                <ul className="pl-4 mt-2">
                  <li className="py-1">Water Proofing</li>
                  <li className="py-1">Interior Work</li>
                  <li className="py-1">Exterior Work</li>
                  <li className="py-1">Vastu Suggestions</li>
                  <li className="py-1">Renovation</li>
                </ul>
              )}
            </li>
            <a href="#aboutUs">
              <li className="text-gray-800 text-lg hover:underline cursor-pointer">
                About Us
              </li>
            </a>
            <a href="#contactUs">
              <li className="text-gray-800 text-lg hover:underline cursor-pointer">
                Contact
              </li>
            </a>
          </ul>
          <div className="flex space-x-4 mt-4 px-4">
            <a href="tel:+919987858709">
              <img
                src="./svgIcons/phone-call-24.svg"
                alt="Phone"
                className="h-6"
              />
            </a>
            <a href="https://wa.me/+919987858709">
              <img
                src="./svgIcons/whatsapp-128.svg"
                alt="WhatsApp"
                className="h-6"
              />
            </a>
            <a href="mailto:adityassociates0510@gmail.com">
              <img
                src="./svgIcons/mail-pencil.svg"
                alt="Email"
                className="h-6"
              />
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
